// extracted by mini-css-extract-plugin
export default {"configGroup":"ConfigsByChips_configGroup__hCS5e","configLabel":"ConfigsByChips_configLabel__6AQpn","configItem":"ConfigsByChips_configItem__m+CTW"};